export default {"src":"/_next/static/media/linkShare.71fbb352.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};